export const ORIGINATING_MODAL_NAME_PUBLISH_SCHEDULE = 'publish_schedule';
export const MODULE_NAME = 'monetization';
export const PARENT_MODULE_NAME = 'monetization';
export const CONTACT_INFORMATION_NUMBER = '(415) 361-5684';
